/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Form_Isnotificationenabled_Label2Inputs */



/**
* | output |
* | --- |
* | "Enable notifications" |
*
* @param {Alarms_Form_Isnotificationenabled_Label2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_form_isnotificationenabled_label2 = /** @type {((inputs?: Alarms_Form_Isnotificationenabled_Label2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Form_Isnotificationenabled_Label2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Enable notifications")
	return /** @type {LocalizedString} */ ("Activer les notifications")
});
export { alarms_form_isnotificationenabled_label2 as "alarms_form_isNotificationEnabled_label" }